import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Flex, Text } from 'Components/Base';

const TargetGoalCardWrapper = styled(Flex)(({ theme, haveGoals }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderRadius: `${theme.radii[2]}px`,
  backgroundColor: haveGoals ? theme.colors.myPath.primary[100] : theme.colors.myPath.gray[100],
  padding: `${theme.space[1]}px ${theme.space[2]}px`,
}));

const TargetGoalCard = ({ haveGoals = false, currentHours, targetHours }) => {
  return (
    <TargetGoalCardWrapper haveGoals={haveGoals}>
      <Text
        textStyle={'caption'}
        color={haveGoals ? 'myPath.primary.500' : 'myPath.textColor.primary'}
        fontWeight={600}
      >
        {haveGoals ? 'เป้าหมายชั่วโมงเรียน' : 'ชั่วโมงเรียนทั้งหมด'}
      </Text>
      {haveGoals ? (
        <Flex flexDirection={'row'} gridColumnGap={1}>
          <Text textStyle={'caption'} color={'myPath.textColor.primary'}>
            {currentHours}
          </Text>
          <Text textStyle={'caption'} color={'myPath.primary.500'}>
            / {targetHours} ชม.
          </Text>
        </Flex>
      ) : (
        <Text textStyle={'caption'} color={'myPath.textColor.primary'}>
          {currentHours} ชม.
        </Text>
      )}
    </TargetGoalCardWrapper>
  );
};

TargetGoalCard.propTypes = {
  haveGoals: PropTypes.bool.isRequired,
  currentHours: PropTypes.string,
  targetHours: PropTypes.string,
};

export default TargetGoalCard;
